export default __webpack_public_path__ + "static/media/ceo2.7dad4d12.jpg";